import Factory from '../factory';

const schema = Factory.schema('video');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('id').setType(String);

export default schema;
